import * as React from 'react';

import { ResponsiveButton } from 'ui/ResponsiveButton/ResponsiveButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import './_buttonMenu.scss';
import { SxProps, Theme } from '@mui/material';

type Props = {
    buttonLabel: React.ReactNode;
    iconElement?: React.ReactElement<React.ComponentProps<'div'>>;
    menuItems: Array<{
        name: string;
        icon?: React.ReactElement<React.ComponentProps<'div'>>;
        action: () => void;
        className?: string;
        dataTestId?: string;
        disabled?: boolean;
    }>;
    extra?: object;
    className?: string;
    sx?: SxProps<Theme>;
};

export function ButtonMenu({
    menuItems,
    buttonLabel,
    extra = undefined,
    iconElement = undefined,
    className = undefined,
    sx = undefined,
}: Props): React.ReactElement {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    // @ts-expect-error [TS migration] (previously $FlowFixMe) type from MUI not correctly typed
    const handleClick = (event: SyntheticInputEvent<Button>) => {
        setOpen(true);
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <ResponsiveButton
                icon={iconElement}
                label={buttonLabel}
                onClick={handleClick}
                extra={extra || {}}
                className={className}
                sx={sx}
            />
            <Menu
                id="icon-menu"
                key="icon-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
            >
                {menuItems.map((menuItem) => [
                    <MenuItem
                        key={menuItem.name}
                        onClick={menuItem.action}
                        className={menuItem.className}
                        data-testid={menuItem.dataTestId}
                        disabled={menuItem.disabled}
                    >
                        {menuItem.icon && (
                            <ListItemIcon>{menuItem.icon}</ListItemIcon>
                        )}
                        {menuItem.name}
                    </MenuItem>,
                ])}
            </Menu>
        </>
    );
}
